/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './buttonStationSelect.module.scss';
import { ReactComponent as Arrow } from '../../assets/arrow.svg';

const ButtonStationSelect = ({
  stationNames,
  selectedStation,
  handleSelectStation,
  handelShowTimetable,
  handleShowMenuStationSelect,
  showMenuStationSelect,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={showMenuStationSelect ? styles.buttonShow : styles.button}
      type="button"
      onClick={handleShowMenuStationSelect}
    >
      <button type="button" className={styles.button__buttonFirst}>
        <p className={styles.button__label}>
          {selectedStation.length === 0 ? t('timetable.selectStation') : selectedStation}
        </p>
        <Arrow className={styles.button__arrow} />
      </button>

      {showMenuStationSelect && (
        <>
          {stationNames
            .filter((station) => station !== selectedStation)
            .filter((station) => station !== 'Rejon Dworca st. 16')
            .flatMap((station, index) => (
              <button
                type="button"
                key={index}
                className={styles.button__button}
                onClick={() => {
                  handleSelectStation(station);
                  handelShowTimetable(station);
                }}
              >
                <p className={styles.button__label}>{station}</p>
              </button>
            ))}
        </>
      )}
    </div>
  );
};

export default ButtonStationSelect;
